import React from 'react'
import { useOutletContext } from 'react-router-dom'

const Accounting: React.FC = () => {
  const { darkMode } = useOutletContext<{ darkMode: boolean }>()

  return (
    <div className={`rounded-lg shadow p-4 md:p-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'}`}>
      <h2 className="text-xl font-semibold mb-4">Virements</h2>
      <p>Contenu des virements à venir...</p>
    </div>
  )
}

export default Accounting